import React from 'react';
import ReviewCard from './ReviewCard';
import './review.scss';
import { GOOGLE_GENERIC_REVIEW } from '../../../hb-redux-store/util/constantServices';

class Reviews extends React.Component {
  state = { activeIndex: 0 };
  carouselRef = React.createRef();
  intervalPromise = null;
  SETTINGS = {
    speed: 5000,
  };

  reviews = GOOGLE_GENERIC_REVIEW;
  componentDidMount() {
    if (this.reviews.reviews?.length > 0) {
      this.intervalPromise = setInterval(this.autoSlide, this.SETTINGS.speed);
    }
  }
  componentWillUnmount() {
    if (this.reviews.reviews?.length && this.intervalPromise) {
      clearInterval(this.intervalPromise);
    }
  }
  autoSlide = () => {
    const { activeIndex } = this.state;
    const { carouselRef } = this;
    const width = this.carouselRef.current?.childNodes[1]?.clientWidth || 0;
    let nextIndex = activeIndex + 1;
    let scrollWidth = nextIndex * width;
    if (activeIndex === this.reviews.reviews.length - 1) {
      scrollWidth = 0;
      nextIndex = 0;
    }
    carouselRef.current.scroll({ left: scrollWidth, behavior: 'smooth' });
    this.setState({ activeIndex: nextIndex });
  };
  render() {
    return (
      <div className="reviews">
        <div className="reviews--title">{this.reviews.title}</div>
        <div className="reviews--cards" ref={this.carouselRef}>
          {this.reviews.reviews.map((r, i) => (
            <ReviewCard {...r} key={i} />
          ))}
        </div>
      </div>
    );
  }
}

export default Reviews;
